import {defineNuxtRouteMiddleware} from "nuxt/app"
import {useLayoutStore} from '~/store/layout'

export default defineNuxtRouteMiddleware((to, from) => {
    useLayoutStore().setCurrentModule(to.meta?.module || 'dashboard')
})